import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useEvalStewardEnabled } from "./useEvalStewardEnabled";

export interface AnnotationHistoryParams {
  workspaceId: string;
  threadId: string;
  assistantMessageIndex: number;
}

export function useAnnotationHistory({
  workspaceId,
  threadId,
  assistantMessageIndex,
}: AnnotationHistoryParams) {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  return useQuery({
    queryKey: [
      "evalSteward",
      "annotationHistory",
      workspaceId,
      threadId,
      assistantMessageIndex,
    ],
    queryFn: () =>
      api.listEvalAnnotationsBySourceRef({
        workspace_id: workspaceId,
        thread_id: threadId,
        assistant_message_index: assistantMessageIndex,
      }),
    enabled:
      isEvalStewardEnabled &&
      Boolean(
        workspaceId &&
          threadId &&
          Number.isFinite(assistantMessageIndex),
      ),
  });
}
